const ItemMasterFormLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
 
            {
                "name": "WarehouseID",
                "tableName": "",
                "label": "WH",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },

            {
                "name": "DateAvailable",
                "tableName": "",
                "label": "DateAvailable",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false
            },
            {
                "name": "AverageCost",
                "tableName": "",
                "label": "Average Cost",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "BomExplosionFlag",
                "tableName": "",
                "label": "Bom Explosion Flag",
                "type": "checkboxGroup",
                "options": ["Bom Explosion Flag"],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "ClassCode",
                "tableName": "",
                "label": "Class",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode1",
                "tableName": "",
                "label": "Code-1 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode2",
                "tableName": "",
                "label": "Code-2 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode3",
                "tableName": "",
                "label": "Code-3 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode4",
                "tableName": "",
                "label": "Code-4 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode5",
                "tableName": "",
                "label": "Code-5 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode6",
                "tableName": "",
                "label": "Code-6 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode7",
                "tableName": "",
                "label": "Code-7 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode8",
                "tableName": "",
                "label": "Code-8 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode9",
                "tableName": "",
                "label": "Code-9 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedCode10",
                "tableName": "",
                "label": "Code-10 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }

        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "ItemCode",
                "tableName": "",
                "label": "Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": true

            },
            {
                "name": "CreationUserId",
                "tableName": "",
                "label": "Created By",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "CreationDateTime",
                "tableName": "",
                "label": "Creation Date",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false
            },
            {
                "name": "LastUpdateDateTime",
                "tableName": "",
                "label": "Date Last Receipt",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate1",
                "tableName": "",
                "label": "Date-1 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate2",
                "tableName": "",
                "label": "Date-2 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate3",
                "tableName": "",
                "label": "Date-3 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate4",
                "tableName": "",
                "label": "Date-4 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate5",
                "tableName": "",
                "label": "Date-5 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate6",
                "tableName": "",
                "label": "Date-6 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate7",
                "tableName": "",
                "label": "Date-7 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate8",
                "tableName": "",
                "label": "Date-8 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate9",
                "tableName": "",
                "label": "Date-9 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UUserDefinedDate10",
                "tableName": "",
                "label": "Date-10 Item",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "DateExpiration",
                "tableName": "",
                "label": "Expiration Date",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "InReceiving",
                "tableName": "",
                "label": "In Receiving",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }

        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "CareInstructions",
                "tableName": "",
                "label": "Instructions",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "DateIntroduced",
                "tableName": "",
                "label": "Introduced Date:",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false
            },
            {
                "name": "InventoryUnitUom",
                "tableName": "",
                "label": "Inventory Unit",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "Available",
                "tableName": "",
                "label": "Available",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "Description_1",
                "tableName": "",
                "label": "Description_1",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "Description_2",
                "tableName": "",
                "label": "Description_2",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "ItemSourceFlag",
                "tableName": "",
                "label": "Item Source",
                "type": "checkboxGroup",
                "options": ["Item Source"],
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "ItemType",
                "tableName": "",
                "label": "Item Type",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "LastCost",
                "tableName": "",
                "label": "Last Cost",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "LastUpdateDateTime",
                "tableName": "",
                "label": "Last Updated",
                "type": "date",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "LastUpdateUserId",
                "tableName": "",
                "label": "Lasat Update By",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "PriceLevelA",
                "tableName": "",
                "label": "Code-7 Item",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "PriceLevelB",
                "tableName": "",
                "label": "Price Level B",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "PriceLevelC",
                "tableName": "",
                "label": "Price Level C",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "PriceLevelD",
                "tableName": "",
                "label": "Price Level D",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "PriceLevelE",
                "tableName": "",
                "label": "Price Level E",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
  
            {
                "name": "OnHand",
                "tableName": "",
                "label": "On Hand",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "Locationmaxunitsforwardpick",
                "tableName": "",
                "label": "Max Units Fwd Pick",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "Locationmaxunitsreplenishment",
                "tableName": "",
                "label": "Max Units Repl",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "Minimumsalesquantity",
                "tableName": "",
                "label": "Min Sales Qty",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "Locationminunitsforwardpick",
                "tableName": "",
                "label": "Min Units Fwd Pick",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "Locationminunitsreplenishment",
                "tableName": "",
                "label": "Min Units Repl",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "WearHouseName",
                "tableName": "",
                "label": "Wear House Name",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "Status",
                "tableName": "",
                "label": "Status:",
                "type": "select",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false
            },
            {
                "name": "UserDefinedQuantity1",
                "tableName": "",
                "label": "Quantity 1",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity2",
                "tableName": "",
                "label": "Quantity 2",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity3",
                "tableName": "",
                "label": "Quantity 3",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity4",
                "tableName": "",
                "label": "Quantity 4",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity5",
                "tableName": "",
                "label": "Quantity 5",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity6",
                "tableName": "",
                "label": "Quantity 6",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity7",
                "tableName": "",
                "label": "Quantity 7",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity8",
                "tableName": "",
                "label": "Quantity 8",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity9",
                "tableName": "",
                "label": "Quantity 9",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedQuantity10",
                "tableName": "",
                "label": "Quantity 10",
                "type": "number",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedReference1",
                "tableName": "",
                "label": "Reference-1 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedReference1",
                "tableName": "",
                "label": "Reference-2 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            },
            {
                "name": "UserDefinedReference1",
                "tableName": "",
                "label": "Reference-3 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "UserDefinedReference4",
                "tableName": "",
                "label": "Reference-4 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "UserDefinedReference5",
                "tableName": "",
                "label": "Reference-5 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "UserDefinedReference6",
                "tableName": "",
                "label": "Reference-6 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "UserDefinedReference7",
                "tableName": "",
                "label": "Reference-7 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "UserDefinedReference8",
                "tableName": "",
                "label": "Reference-8 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "UserDefinedReference9",
                "tableName": "",
                "label": "Reference-3 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }
            ,
            {
                "name": "UserDefinedReference10",
                "tableName": "",
                "label": "Reference-10 Item",
                "type": "text",
                "options": null,
                "apiUrl": null,
                "grid": null,
                "required": false,
                "visible": false

            }

        ]
    }
];
export default ItemMasterFormLayout;